import { render } from "./saveBar.vue?vue&type=template&id=96b6bed0&scoped=true"
import script from "./saveBar.vue?vue&type=script&lang=js"
export * from "./saveBar.vue?vue&type=script&lang=js"

import "./saveBar.vue?vue&type=style&index=0&id=96b6bed0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b6bed0"]])

export default __exports__